import { observer } from "mobx-react-lite"

type TitleVariant = "h1" | "h2" | "h3"

interface ITitleProps {
	variant?: TitleVariant
	children: string
}

const getVariantStyle = (variant: TitleVariant) => {
	switch (variant) {
		case "h1": {
			return "text-[34px] leading-[34px]"
		}
		case "h3": {
			return "text-[14px] leading-[14px]"
		}
		case "h2":
		default: {
			return "text-[18px] leading-[18px]"
		}
	}
}

export const Title = observer(({ variant = "h2", children }: ITitleProps) => {
	return <span className={`font-semibold ${getVariantStyle(variant)}`}>{children}</span>
})
